import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CameraFilters } from '../../../camera/repository/camera-api.repository.types';
import { CameraApiService } from '../../../camera/service/camera-api.service';
import { Camera } from '../../../camera/service/camera-api.service.model';
import { HorusApiServiceModel } from './horus-api.service.model';

@Injectable({
  providedIn: 'root',
})
export class HorusApiService implements HorusApiServiceModel {
  cameraApiService = inject(CameraApiService);
  getCameras(filters: CameraFilters): Observable<Camera[]> {
    return this.cameraApiService
      .getCameras(filters)
      .pipe(map((res) => res.items));
  }
}
